"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nArgs = void 0;
/**
 * Interface to define a specific input into a query that will allow building
 * input data using the Builder pattern.
 *
 * Each configuration type will have its own implementation to provide query
 * specific inputs.
 */
class I18nArgs {
    toString() {
        let res = `${this.constructor.name}:{`;
        let argsCount = 0;
        for (const entry of this.getArgsMap().entries()) {
            res += `${entry[0]}:${entry[1]}`;
            argsCount++;
            if (argsCount != this.getArgsMap().size) {
                res += ',';
            }
        }
        res += '}';
        return res;
    }
}
exports.I18nArgs = I18nArgs;
//# sourceMappingURL=i18n-args.js.map